import { useEffect, useState } from "react";
import { Button, notification, Table, Typography, Tag } from "antd";
import Page from "../../../elements/Page";

import HeaderItem from "../../../elements/HeaderItem";
import TableHead from "./TableHead";
import REQUESTS from "../../../../server/requests";
import ICONS from "../../../../config/icons";
import TableButtons from "../../../elements/TableButtons";
import ImageComponent from "../../../elements/ImageComponent";
import confirm from "antd/lib/modal/confirm";
import StoryDrawer from "./drawer/StoryDrawer";
import { useSelector } from "react-redux";
import EN from "../../../../config/en";
import AddButtonComponent from "../../../elements/AddButtonComponent";

const CustomerStoryPage = () => {
  const translation = useSelector((state) => state.globalState.translate);

  let debounceTimeOut;

  const [dataSource, setDataSource] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [showDrawer, setShowDrawer] = useState(false);
  const [editable, setEditable] = useState(null);
  const [loading, setLoading] = useState(false);

  const [total, setTotal] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [sort, setSort] = useState(["id", "DESC"]);

  const columns = [
    {
      title: "#",
      dataIndex: "id",
      key: "id",
      align: "center",
      width: 50,
      fixed: "left",
    },
    {
      title: translation["Image"] || EN["Image"],
      dataIndex: "image",
      key: "image",
      align: "center",
      render: (text, record) => {
        return <ImageComponent src={text} className="tableImage" />;
      },
    },
    {
      title: translation["Name"] || EN["Name"],
      dataIndex: "name",
      key: "name",
      align: "center",
      //   width: 150,
    },
    {
      title: translation["Country"] || EN["Country"],
      dataIndex: "country",
      key: "country",
      align: "center",
    },
    {
      title: translation["Rating"] || EN["Rating"],
      dataIndex: "rating",
      key: "rating",
      align: "center",
    },
    {
      title: translation["Feedback"] || EN["Feedback"],
      dataIndex: "feedbacks",
      key: "feedbacks",
      align: "center",
      ellipsis: true,
    },
    {
      title: "",
      dataIndex: "actions",
      key: "actions",
      align: "center",
      fixed: "right",
      width: 100,
      render: (text, record) => (
        <TableButtons
          handleMenuClick={(key) => handleMenuClick(key, record)}
          buttons={[
            {
              text: translation["Edit"] || EN["Edit"],
              key: "edit",
              icon: ICONS.EDIT,
            },
            {
              text: translation["Delete"] || EN["Delete"],

              key: "delete",
              icon: ICONS.DELETE,
            },
          ]}
        />
      ),
    },
  ];

  const getDataSource = () => {
    setLoading(true);

    const query = {
      limit,
      page: currentPage,
      total,
      sort,
    };

    const successCallBack = (data) => {
      setLoading(false);
      setDataSource(data?.rows);
      console.log(data);
    };

    const errorCallBack = (err) => {
      setLoading(false);
      console.log(err);
    };

    try {
      REQUESTS.BOOKING.CUSTOMER_STORY.GET(query, successCallBack, errorCallBack);
    } catch (error) {
      setLoading(false);
      throw error;
    }
  };

  const handleMenuClick = ({ key }, record) => {
    console.log(key);

    switch (key) {
      case "edit":
        setEditable(record);
        setShowDrawer(true);

        break;
      case "delete":
        confirm({
          title: translation["Do you want to delete"] || EN["Do you want to delete"],
          onOk() {
            handleDelete(record.id);
          },
        });
        break;
      default:
        break;
    }
  };

  const getCountry = () => {
    try {
      REQUESTS.COUNTRY.GET(
        {},
        (data) => {
          const newGenresList = data.map((item) => {
            return { label: item.name, value: item.id };
          });
          setCountryList(newGenresList);
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (error) {
      console.log(error);
    }
  };

  const handleAddAboutInfo = (values) => {
    setLoading(true);

    clearTimeout(debounceTimeOut);

    debounceTimeOut = setTimeout(() => {
      if (editable) {
        try {
          REQUESTS.BOOKING.CUSTOMER_STORY.EDIT(
            // { ...values, id: editable.id },
            values,
            editable?.id,

            (data) => {
              setLoading(false);
              notification.success({
                message:
                  translation["Customer story updated successfully"] ||
                  EN["Customer story updated successfully"],
              });
              setEditable(null);
              setShowDrawer(false);
              getDataSource();
            },
            (error) => {
              setLoading(false);

              console.log(error);
            }
          );
        } catch (error) {
          setLoading(false);

          console.log(error);
        }
      } else {
        try {
          REQUESTS.BOOKING.CUSTOMER_STORY.ADD(
            values,
            (data) => {
              setLoading(false);

              notification.success({
                message:
                  translation["Customer story added successfully"] ||
                  EN["Customer story added successfully"],
              });
              setShowDrawer(false);
              getDataSource();
            },
            (error) => {
              setLoading(false);

              console.log(error);
            }
          );
        } catch (error) {
          setLoading(false);

          console.log(error);
        }
      }
    }, 1000);
  };

  const handleDelete = (id) => {
    setLoading(true);
    try {
      REQUESTS.BOOKING.CUSTOMER_STORY.DELETE(
        id,
        (data) => {
          setLoading(false);
          getDataSource();
          notification.success({
            message:
              translation["Customer story deleted successfully"] ||
              EN["Customer story deleted successfully"],
          });
        },
        (error) => {
          setLoading(false);
          console.log(error);
        }
      );
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const handleTableChange = (pagination) => {
    setCurrentPage(pagination.current);
    setLimit(pagination.pageSize);
    setTotal(pagination.total);
  };

  useEffect(() => {
    getDataSource();
  }, [currentPage, limit, total]);

  useEffect(() => {
    getCountry();
  }, []);

  return (
    <Page>
      <div className="page-body">
        <h1>{translation["Customer Story"] || EN["Customer Story"]}</h1>
        <HeaderItem title={"Total"} total={dataSource?.length} />
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "20px",
          }}
        >
          <TableHead>
            <div
              style={{
                display: "flex",
                justifyContent: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <AddButtonComponent
                text={translation["Add customer story"] || EN["Add customer story"]}
                onClick={() => {
                  setShowDrawer(true);
                  setEditable(null);
                }}
              />
            </div>
          </TableHead>
        </div>
        <Table
          columns={columns}
          dataSource={dataSource}
          onChange={handleTableChange}
          loading={loading}
          pagination={{
            position: ["bottomCenter"],
            current: currentPage,
            pageSize: limit,
            total: total,
            limit,
            showSizeChanger: true,
          }}
        />
      </div>
      <StoryDrawer
        visible={showDrawer}
        onClose={() => {
          setShowDrawer(false);
          setEditable(null);
        }}
        editable={editable}
        country={countryList}
        addMusic={handleAddAboutInfo}
        loading={loading}
      />
    </Page>
  );
};

export default CustomerStoryPage;
